import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "../components/BackButton";
import "../css/Relatorios.css";
import {
  FaChartLine,
  FaClipboardList,
  FaChartBar,
  FaTrashAlt,
  FaArrowLeft,
} from "react-icons/fa";

const Relatorios = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="relatorios-container">
      <BackButton inline />
      <h2>Relatórios</h2>
      <div className="relatorios-buttons">
        <button
          onClick={() =>
            handleNavigate(`/restaurantes/${id}/relatorios/aproveitamento`)
          }
        >
          <FaChartLine />
          Relatório de Aproveitamento de Ingredientes
        </button>
        <button
          onClick={() =>
            handleNavigate(`/restaurantes/${id}/relatorios/rotina`)
          }
        >
          <FaClipboardList />
          Relatório de Rotina
        </button>
        <button
          onClick={() =>
            handleNavigate(`/restaurantes/${id}/relatorios/producao`)
          }
        >
          <FaChartBar />
          Relatório de Produção
        </button>
        <button
          onClick={() =>
            handleNavigate(`/restaurantes/${id}/relatorios/desperdicio`)
          }
        >
          <FaTrashAlt />
          Relatório de Desperdício de Ingredientes
        </button>
        <button
          onClick={() => handleNavigate(`/restaurantes/${id}/relatorios/notas`)}
        >
          <FaClipboardList />
          Notas
        </button>
      </div>
    </div>
  );
};

export default Relatorios;
